import { useQuery } from "react-query";
import { getComplianceInfo, getMetadataCoporate } from "./request";
import { IComplianceInfo, MetaDataCoporate } from "./types";

export const useGetComplianceInfo = (params?: any, options?: any) => {
	return useQuery<IComplianceInfo>(
		["/corporate-investors/compliance", params],
		async () => getComplianceInfo(params),
		options,
	);
};

export const useGetMetaDataCoporate = (params?: any, options?: any) => {
	return useQuery<MetaDataCoporate>(
		["/metadata/corporate-investors", params],
		() => getMetadataCoporate(params),
		options,
	);
};
